// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
import {HttpService} from "../../../services/HttpService";
import {IRegion} from "../../../interfaces/IRegion";
import {ILanguage} from "../../../interfaces/ILanguage";
import {HeaderDefault} from "../header_default/HeaderDefault";
import {Footer} from '../footer/Footer';
import {IUserinfo} from "../../../interfaces/IUserinfo";

@Component({
    mixins: [template],
    components: {
        HeaderDefault,
        Footer
    }
})
export class HeaderFooterApplicationFuso extends Vue {

    private readonly http: HttpService = HttpService.instance

    public headerRegions: IRegion[] = []

    @Prop()
    public appId!: string

    @Prop()
    public language!: string;

    @Prop()
    public country!: string;

    @Prop({default: () => { return window.location.origin}})
    public redirectUrlAfterLogout!: string

    @Prop({default: () => { return window.location.origin}})
    public homeLink!: string

    @Prop({default: () => { return [] }})
    public supportedLanguages!: ILanguage[]

    @Prop({default: false})
    public willProvideRegions!: boolean

    @Prop({default: () => { return [] }})
    public supportedRegions!: IRegion[]

    @Prop({default: false})
    public disableAuth!: boolean

    @Prop({default: null})
    public options!: object | null

    private appInfo: any = null;

    public get assetsUrl() {
        return APP_ASSETS_URL
    }

    public navigation: object[] = []

    public get fusoOptions() {
        return {
            topMenuBefore: [],
            menu: this.navigation.map(item => {
                let result = {
                    id: item['id'],
                    href: item['url'],
                    text: item['title']
                }

                if (item['children']) {
                    result['children'] = item['children'].map(it => {
                        return {
                            id: it['id'],
                            href: it['url'],
                            text: it['title']
                        }
                    })
                }

                return result
            })
        }
    }

    get anbieterUrl() {
        if (this.appInfo) {
            return this.appInfo['anbieter_url']
        } else {
            return null;
        }
    }

    get rechtlicheHinweiseUrl() {
        if (this.appInfo) {
            return this.appInfo['rechtliche_hinweise_url']
        } else {
            return null;
        }
    }

    get cookiesUrl() {
        if (this.appInfo) {
            return this.appInfo['cookies_url']
        } else {
            return null;
        }
    }

    get datenschutzUrl() {
        if (this.appInfo) {
            return this.appInfo['datenschutz_url']
        } else {
            return null;
        }
    }

    get copyrightText() {
        if (this.appInfo) {
            return this.appInfo['footer_text']
        } else {
            return null;
        }
    }

    public created() {
        this.loadApplikationInfo();
        this.loadFusoNavigation();
    }

    public async loadApplikationInfo() {
        let appId = 44 // Hardcode App ID for FUSO
        let url = `/api/identity/v1.0/${this.language}/applikation/${appId}/disclaimer`;
        let response = await this.http.get<any[]>(url);

        this.appInfo = response.body!
    }

    public async loadFusoNavigation() {
        let url = `/api/cms/${this.language}/GLOBAL/fuso-navigation`;
        let response = await this.http.get<object[]>(url)

        this.navigation = response.body!
    }

    public handleFooterClick(itemName) {
        // @ts-ignore
        this.$refs['Header'].openPolicy(itemName);
    }
}
